import Component from "../abstracts/Component";

export default class HeroZoomMobile extends Component {
  get SELECTORS() {
    return {
      main: '.js-hero-zoom-mobile',
      slide: '.js-hero-zoom-slide',
      dots: '.js-hero-zoom-dots',
      dot: '.js-hero-zoom-dot'
    }
  }

  get CLASSES() {
    return {
      active: 'is-active',
      left: {
        out: 'out-left',
        in: 'in-left'
      },
      right: {
        out: 'out-right',
        in: 'in-right'
      }
    }
  }

  constructor() {
    super()
  }

  //50 is tolerance 
  getDirection(val) {
    if (this.ts > val + 50) {
      return 'left'
    } else if (this.ts < val - 50) {
      return 'right'
    }
  }

  getHeight(slides) {
    return new Promise((resolve, reject) => {
      try {
        let height = 0;
        slides.forEach(slide => {
          height = height < slide.clientHeight ? slide.clientHeight : height;
        });
        resolve(height);
      } catch (e) {
        reject(false)
      }
    });
  }

  animateOut(direction, slide) {
    return new Promise((resolve, reject) => {
      try {
        slide.classList.add(this.CLASSES[direction].out);
        resolve(this.CLASSES[direction].out);
      } catch (e) {
        reject(e);
      }
    });
  }

  animateIn(outClass, element) {
    return new Promise((resolve, reject) => {
      try {
        const slide = element.cloneNode(true);
        const parent = element.parentNode;
        setTimeout(() => {
          parent.insertBefore(slide, element.parentElement.lastElementChild);
          parent.removeChild(element);
          parent.appendChild(slide);
          resolve(slide);
        }, 300);
      } catch (e) {
        reject(e);
      }
    });
  }

  selectDots(element) {
    return new Promise((resolve, reject) => {
      try {
        const dotsContainer = element.parentElement.nextSibling;
        const dots = dotsContainer ? dotsContainer.querySelectorAll(this.SELECTORS.dot) : false;
        const activeIndex = element.parentElement.firstElementChild.dataset.herozoomIndex;
        if (!dots) {
          return resolve(false);
        } else {
          dots.forEach(dot => {

            if (dot.dataset.herozoomIndex === activeIndex) {
              dot.classList.add(this.CLASSES.active);
            } else {
              dot.classList.remove(this.CLASSES.active);
            }
          });
        }
      } catch (e) {
        reject(e);
      }

    });

  }

  bindSwipe() {
    this.$on('touchstart.heroMobile', ({event}) => {
      this.ts = event.originalEvent.touches[0].clientX;
    }, `${this.SELECTORS.main} ${this.SELECTORS.slide}`);

    this.$on('touchend.heroMobile', ({event}) => {
      const te = event.originalEvent.changedTouches[0].clientX;
      const target = event.currentTarget;
      const direction = this.getDirection(te);

      this.animateOut(direction, target).then((outClass) => {
        this.animateIn(outClass, target).then(slide => {
          this.selectDots(slide);
          setTimeout(() => {
            slide.classList.remove(outClass);
          }, 200);
        });
      });

    }, 'body', this.SELECTORS.slide);
  }

  init() {
    const cardsContainers = document.querySelectorAll(this.SELECTORS.main);

    cardsContainers.forEach(container => {
      const sides = container.querySelectorAll(this.SELECTORS.slide);
      this.getHeight(sides).then(res => {
        if (res) container.style.height = `${res + 100}px`;
        this.bindSwipe();
      }); //padding-top + padding-bottom = 100

    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.main) && this.$matchMedia('sm')) {
      this.init();
    }
  }
}
